import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'OFFLINE_PAYMENT_POST',
  POST_SUCCESS: 'OFFLINE_PAYMENT_POST_SUCCESS',
  POST_FAILURE: 'OFFLINE_PAYMENT_POST_FAILURE',
};

export const post = actions.post(
  (id, value, { studentId }) => `${BASE_URL}/students/${studentId}/offline-payment-link/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);
